import React from 'react';

const PlantSelector = ({ plantas, selectedPlantId, onSelectPlant }) => {
  return (
    <div className="bg-white p-6 rounded-2xl shadow-lg max-w-2xl mx-auto mb-6 transition-colors duration-300">
      <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">Selecciona una Planta</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {plantas.map(plant => (
          <button
            key={plant.id}
            onClick={() => onSelectPlant(plant.id)}
            className={`py-3 px-4 rounded-lg font-semibold transition-colors border-2 text-base ${
              selectedPlantId === plant.id
                ? 'bg-indigo-600 text-white border-indigo-600 shadow-md'
                : 'bg-gray-100 text-gray-800 border-gray-200 hover:bg-gray-200'
            }`}
          >
            {plant.nombre}
          </button>
        ))}
      </div>
    </div>
  );
};

export default PlantSelector;